import ShButton from '@/components/Helpers/ShButton';

// @vue/component
export default {
  name: 'SmsQueueSearchPanel',

  components: {
    ShButton,
  },

  props: {
    projectsList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      searchParams: {
        project: '',
        number: '',
        status: '',
        date: null,
      }
    };
  },

  computed: {
    statusList() {
      return this.$store.getters['sms/statusList'];
    },
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes(['sms/getSmsQueueList'])
    },
  },

  watch: {
    searchParams: {
      handler(newVal) {
        this.$emit('changeFilterBy', newVal);
      },
      deep: true,
    },
  },

  methods: {  
    clearSearchParams() {
      this.searchParams.number = '';
      this.searchParams.status = '';
      this.searchParams.date = null;
      this.searchParams.project = '';
    }
  },
};
